import React, { useRef, useState, useEffect} from 'react';

import { useBranchContext } from '../Context/BranchContext';


import BranchForm from '../../views/PartnerView/BranchForm';
import BranchDetailsDisplay from '../../views/PartnerView/BranchIdForm';
import BranchAdminView from '../../views/PartnerView/BranchAdminView';



const BranchComponent = () => {

    const data = useRef('');
    const [loading,setLoading] = useState(true);
    const didFetch = useRef(false); 

    const error = useRef('');
    const { FetchServiceCategory,category,FetchBranches,FetchBranchById,branches} = useBranchContext();
    
    const getData = async () => {
       
        try {
                await FetchServiceCategory();
              
                setLoading(false); // Set loading to false once data is fetched
           
        
        } catch (error) {
            console.error('Error fetching data:', error);
            error.current= 'Failed to fetch data.';
        }
    };

    useEffect(() => {
        if (!didFetch.current) {
          getData();    
          didFetch.current = true; // Mark the API call as done
        }
      });
    
    
    return <div>
   {/* {loading && <div>Loading...</div>}*/}
        {!loading && category != null && <BranchForm />}
    </div>
    // return <PartnerView Partnersdata={partners}/>
   
};

export default BranchComponent;
